export default {
  customProduct: {
    CustomProduct: 'Custom Product',
    Status: 'État',
    SampleFee: "frais d'échantillonnage",
    inputPlaceholder: "recherche par nom de produit ou numéro d'exigence",
    AddNewDemand: 'ajouter une nouvelle exigence',
    Product: 'produit',
    AddedTime: 'added time',
    DemandStatus: 'État de la demande',
    PaymentStatus: 'payment status',
    Action: 'action',
    Details: 'détails',
    DemandNo: 'required no',
    More: 'plus',
    Edit: 'Édition',
    PaySampleFee: 'Pay Sample fee',
    PaymentRecords: 'dossiers de paiement',
    Cancel: 'annuler',
    Unreceived: 'non reçu',
    Received: 'reçu',
    Completed: 'terminé',
    Canceled: 'annuler',
    Published: 'publié',
    Unpaid: 'impayé',
    Paid: 'payé',
    CreatedTime: 'Créer du temps',
    TransactionTime: 'Heure de la transaction',
    Amount: 'Nombre',
    PaySampleFeeTips: "S'il vous plaît payer la taxe d'échantillonnage, la commande d'échantillon peut être générée après le paiement",
    PaymentAmount: 'Montant du paiement',
    PaymentMethod: 'Mode de paiement',
    CreditCard: 'Carte de crédit',
    Balance: 'Équilibre',
    Confirm: 'Confirmation',
    transactionError: 'Générer une exception de commande de transaction',
    CustomProcess: 'Processus personnalisé',
    stepTitle1: 'Soumettre vos exigences personnalisées',
    stepDescription1_1: 'Cliquez sur',
    stepDescription1_2: 'Bouton pour remplir les informations sur le produit à personnaliser.',
    stepTitle2: 'Contactez notre représentant du service à la clientèle',
    stepDescription2: 'Notre représentant du service à la clientèle vous enverra un courriel de contact pour vous informer de vos besoins personnalisés.',
    stepTitle3: 'Paiement et livraison des échantillons',
    stepDescription3: "Le client paie les frais d'échantillonnage et kakaclo envoie l'échantillon au client pour confirmation.",
    stepTitle4: 'Confirmation des échantillons et production officielle',
    stepDescription4: "Une fois l'échantillon confirmé, vous pouvez contacter notre représentant du service à la clientèle pour commencer la production officielle."
  },
  customDetail: {
    Back: 'Reviens!',
    AddNewDemand: 'Ajouter une nouvelle demande',
    Style: 'Style',
    ProductName: 'Nom du produit',
    ProductNamePlace: 'T - shirts, jupes, vestes, etc.',
    ContactEmail: 'Contact Email',
    ContactEmailPlace: 'Saisissez un numéro de courriel valide',
    PhoneNumber: 'Numéro de téléphone',
    EstimatedOrderQuantity: 'Nombre estimatif de commandes',
    EstimatedOrderQuantityPlace: 'Nombre de produits commandés',
    ColorQuantity: 'Colorimétrie',
    ColorQuantityPlace: 'Combien de couleurs voulez - vous personnaliser?',
    SizeQuantity: 'Nombre de tailles (par couleur)',
    SizeQuantityPlace: 'Combien de tailles voulez - vous personnaliser?',
    ReferenceLinking: 'Liens de référence',
    ReferenceLinkingTooltip: 'Lien vers le produit à personnaliser.',
    ReferenceLinkingPlace: "Saisissez l'adresse du lien",
    Description: 'Description',
    DescriptionPlace: 'Veuillez nous donner les détails du produit que vous souhaitez personnaliser.',
    Image: 'Image',
    ImageTip: "(jusqu'à 10 images peuvent être affichées.)",
    Fabric: 'Tissu',
    Category: 'Catégorie',
    FabricName: 'Nom du tissu',
    CategoryPlace: 'Lin, coton, etc.',
    Weight: 'Poids (g)',
    WeightPlace: 'Poids du tissu',
    Composition: 'Composition',
    Add: 'Plus',
    Accessories: 'Accessoires',
    Printing: 'Impression',
    PrintingType: "Type d 'impression",
    PrintingTypePlace: 'Impression de pigments, etc.',
    ReferenceLinkingPlace2: 'Liens de référence pour les modes',
    Width: 'Largeur(cm)',
    WidthPlace: 'Largeur du motif',
    Length: 'Longueur(cm)',
    LengthPlace: 'Longueur du motif',
    Position: 'Emplacement',
    PositionPlace: "Position d'impression sur les vêtements",
    Description2: 'Description du modèle',
    Embroidery: 'Broderie',
    PrintingType2: 'Décalcomanies, patchs brodés, etc.',
    Color: 'Couleur',
    Washing: 'Lavage',
    WashingType: 'Type de lavage',
    WashingTypePlace: 'Lavage de la pierre, lavage enzymatique, etc.',
    PositionPlace2: 'Où dois - je nettoyer?',
    OtherTechnology: 'Autres technologies',
    TechnologyName: 'Nom technique',
    Submit: 'Obéissance',
    InputContent: 'Entrée',
    edit: 'Édition',
    detail: 'Détails',
    onlyPictures: 'Seules les images peuvent être téléchargées',
    pictureSize: "Prise en charge maximale de l'image: 5m, format: JPG, PNG, GIF"
  },
  touristCustom: {
    SubmittedSuccessfully: 'Soumis avec succès',
    tip1: 'Cliquez sur contacter le service à la clientèle ci - dessous pour communiquer vos besoins personnalisés',
    tip2: 'Ou attendre patiemment que le service à la clientèle vous contacte',
    back: 'Derrière.',
    CustomProduct: 'Produits sur mesure',
    AddedTime: 'Temps supplémentaire',
    DemandNo: 'Numéro de la demande',
    Home: 'La maison'
  }
}

